var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-button',{attrs:{"type":"primary","block":""},on:{"click":_vm.OnQRcode}},[_vm._v("点击按钮进行验证")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }